import React, { useEffect, useMemo, useState } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { Layout } from 'antd';

import AppLoading from './components/plat/loading/loading';
import Header from './components/plat/header';
import AppLogin from './components/plat/login/Login';
import SafeLogin from './components/plat/login/safeLogin';
import SettlementEvidence from './components/plat/settlementEvidence';
import CrumbsNav from './components/plat/nav/crumbs';
import SliderNav from './components/plat/nav/slider';

import { RootRouter } from "./routes/Router";

import {
    isLogged,
    readLoginPath,
    readSiderWidth,
    writeLoginPath,
    writeAccessToken,
    writeUserInfo,
    writeTenantCode,
    writeTenantConfiguration,
    writeCheckAgreement,
} from './utils/storage';
import { publishLogin, subscribeLogin, subscribeLogout, subscribeRedirectSingup, subscribeSignup, subscribeSliderWidth } from './utils/ps';

import 'antd/dist/antd.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './style/App.less';


const { Content, Sider } = Layout;

const App = ()=> {

  const loginPath = useMemo(()=> readLoginPath(), []);

  const [view, setView] = useState('view')
  const [siderWidth, setSiderWidth] = useState(()=> readSiderWidth() + 'px')

  useEffect(()=> {

    // 必须先注册登录事件监听，这样下面 publishLogin 才能正确切换视图
    subscribeLogin(()=> {
      setView('intoApp')
    })

    // URL 参数免登录：从芋道等外部系统 iframe 跳转过来时直接写入登录态
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userCode = urlParams.get('userCode');
    const roleCode = urlParams.get('roleCode');
    const tenantCode = urlParams.get('tenantCode');
    const roleCodes = urlParams.get('roleCodes');
    const userName = urlParams.get('userName') || userCode || '';
    const tenantName = urlParams.get('tenantName') || tenantCode || '';
    const tenantConfig = urlParams.get('tenantConfig');

    if (token && userCode && roleCode && tenantCode) {
      writeAccessToken(token);
      writeTenantCode(tenantCode);
      writeCheckAgreement(true);

      // 解析 tenantConfig，兼容君实 label 强转逻辑
      let parsedTenantConfig: any = { label: '受试者' };
      if (tenantConfig) {
        try {
          parsedTenantConfig = JSON.parse(tenantConfig);
          if (parsedTenantConfig && parsedTenantConfig.label === 1) {
            parsedTenantConfig.label = '患者';
          } else if (!parsedTenantConfig || parsedTenantConfig.label == null) {
            parsedTenantConfig = { label: '受试者' };
          }
        } catch (e) {
          parsedTenantConfig = { label: '受试者' };
        }
      }
      writeTenantConfiguration({
        enableMenu: null,
        enableNewUi: null,
        hiddenVisitDate: null,
        hiddenField: null,
        label: parsedTenantConfig.label || '受试者',
        route: '',
        ...parsedTenantConfig,
      } as any);

      writeUserInfo({
        roleCode,
        roleCodes: roleCodes ? roleCodes.split(',').map((s: string) => s.trim()).filter(Boolean) : [roleCode],
        userCode,
        userName,
        tenantName,
        tenantCode,
      });

      publishLogin();

      // 清理 URL 参数，避免 token 等信息暴露在地址栏
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }

    subscribeSliderWidth((value)=> {
      setSiderWidth(value)
    })

    subscribeLogout(()=> {
      setView('login')
    })
   
    subscribeRedirectSingup(()=> {
      setView('register')
    })

    subscribeSignup(()=> {
      setView('login')
    })

    writeLoginPath(window.location.pathname)

    // return ()=> {
    //   unsubscribeLogin()
    //   unsubscribeSignup()
    //   unsubscribeLogout()
    //   unsubscribeSliderWidth()
    //   unsubscribeRedirectSignup()
    // }
  }, [])

  // 已登录
  let children = null
  if (view == 'intoApp' || isLogged()) {
      children = (
        <>
          <Header />
          <Layout hasSider className="content">
            <Sider width={siderWidth} collapsedWidth={0} theme='light'>
              <SliderNav onResize={({ width })=> setSiderWidth(`${width}px`)}/>
              {/* <MenuNav getValue={handleWidth} getMouseUpVal={handleWidth}/> */}
            </Sider>
            <Content style={{width: `calc(100vw - ${siderWidth})`}}>
              <CrumbsNav/>
              <RootRouter/>
            </Content>
          </Layout>
        </>
      )
  } else {
      children = (
        <Switch>
          <Route exact path="/login" component={AppLogin} />
          <Route exact path="/settlementLg" component={SettlementEvidence} />
          {/* <Route exact path="/register" component={AppRegister} /> */}
          <Route exact path="/safeLogin" component={SafeLogin} />
          <Redirect exact={view == 'intoApp'} from={'/'} to={{ pathname: `${loginPath == '/safeLogin' ? '/safeLogin' : '/login'}` }} />
        </Switch>
      )
  }

  return (
    <Router>
      <Layout className="app">
        <AppLoading />
        <Layout className="omz-fit">{children}</Layout>
      </Layout>
    </Router>
  )
}

export default App